import { Input, type InputProps } from "../core/Input/Input";
import { useFieldConnection, type ConnectedFieldProps } from "./useFieldConnection";

export interface TextFieldProps
  extends Omit<InputProps, "name">,
    ConnectedFieldProps {}

/**
 * El campo base: un `Input` ya cableado al formulario que lo envuelve.
 *
 * Todo lo demás (`label`, `placeholder`, `hint`, `icon`, `required`…) viaja
 * tal cual a `Input`, así que la accesibilidad —`htmlFor`, `aria-describedby`,
 * `aria-invalid`, los ids de error y pista— sigue siendo exactamente la que
 * `Input` ya resolvía. Este componente no toca ARIA: solo deja de obligar a
 * las pantallas a pasar `register`, `error` y `disabled` a mano.
 *
 * Cualquier prop explícito GANA sobre lo que viene del formulario: pasar
 * `disabled` o `error` a mano sigue siendo posible (una pantalla de solo
 * lectura, un error que no viene de la validación).
 */
export function TextField({
  name,
  registerOptions,
  disabled,
  error,
  ...rest
}: TextFieldProps) {
  const field = useFieldConnection(name, registerOptions);

  return (
    <Input
      {...rest}
      disabled={disabled ?? field.disabled}
      error={error ?? field.error}
      {...field.registration}
    />
  );
}
